module.exports = __webpack_public_path__ + "static/591-368ea975711167df0f86adaa55adc554.png";